export function blogTagUrl(tag: string): string {
  return `/blog?tag=${encodeURIComponent(tag)}`;
}
